import { translate } from '../../../helpers/locale-helpers';

export const downloadPickerTranslation = () => ({
    headerSelectText: translate(
        'Download Picker - Please select the style of the report required.'
    ),
    headerWarningText: translate(
        'Download Picker - (NOTE: Large reports may take several minutes to download)'
    ),
    reportFormatHeaderText: translate('Download Picker - Report Format *'),
    reportFormatFooterText: translate('Download Picker - * Required Selection'),
    reportTypeHeaderText: translate('Download Picker - Report Style *')
});



// WEBPACK FOOTER //
// ./components/sub-heading/download-report/download-picker-translation.js